import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
//import { useAdminAuthContext } from "./administrator/admin/useAdminAuthContext";
//import { useCustomerAuthContext } from "./customer/commoncomponents/useCustomerAuthContext";
//import { useBusinessAuthContext } from "./business/commoncomponents/useBusinessAuthContext";

import AdminProtectedRoute from "./administrator/admin/AdminProtectedRoute";
import BusinessProtectedRoute from "./business/commoncomponents/BusinessProtectedRoute";
import CustomerProtectedRoute from "./customer/commoncomponents/CustomerProtectedRoute";

import { AdminLogin } from "./administrator/admin/AdminLogin";
import { AdminDashboard } from "./administrator/admin/AdminDashboard";
import { AdminManage } from "./administrator/admin/AdminManage";
import { AdminCreate } from "./administrator/admin/AdminCreate";
import Home from "./Home";

import TestCustomerHome from "./customer/test/TestCustomerHome";
import TestWaiverStart from "./customer/test/TestWaiverStart";
import TestCustomerLogin from "./customer/test/TestCustomerLogin";

//import WaiverStart from "./del_old_code/waiver/WaiverStart";
/*import CustomerVerifyOTP from "./customer/commoncomponents/VerifyOTP";
import CustomerHome from "./customer/commoncomponents/CustomerHome";
import CustomerDOB from "./customer/commoncomponents/CustomerDOB";
import CustomerGuardianVerifyOTP from "./customer/commoncomponents/CustomerGuardianVerifyOTP";
import CustomerEditProfile from "./customer/commoncomponents/CustomerEditProfile";
import CustomerChangePhone from "./customer/commoncomponents/CustomerChangePhone";
import CustomerVerifyNewPhone from "./customer/commoncomponents/CustomerVerifyNewPhone";*/
import BusinessRegister from "./business/commoncomponents/BusinessRegister";
import BusinessVerifyEmail from "./business/commoncomponents/BusinessVerifyEmail";
import BusinessLogin from "./business/commoncomponents/BusinessLogin";
import BusinessDashboard from "./business/commoncomponents/BusinessDashboard";
import RecentActivityList from "./business/commoncomponents/RecentActivityList";
import BusinessEditProfile from "./business/commoncomponents/BusinessEditProfile";
//import BusinessManageWaiver from "./business/BusinessManageWaiver";

import BusinessExistingWaivers from "./business/waiverbuilder/BusinessExistingWaivers";
import BusinessCreateWaiverType from "./business/waiverbuilder/BusinessCreateWaiverType";
import BusinessCustomWaiverComingSoon from "./business/waiverbuilder/BusinessCustomWaiverComingSoon";
import BusinessSmartTemplateStep1 from "./business/waiverbuilder/BusinessSmartTemplateStep1";
import BusinessSmartTemplateStep2 from "./business/waiverbuilder/BusinessSmartTemplateStep2";
import LocationCreateForm from "./business/commoncomponents/LocationCreateForm";
import BusinessSmartTemplateStep3 from "./business/waiverbuilder/BusinessSmartTemplateStep3";
import BusinessSmartTemplateStep4 from "./business/waiverbuilder/BusinessSmartTemplateStep4";
import BusinessSmartTemplateStep5 from "./business/waiverbuilder/BusinessSmartTemplateStep5";
import BusinessSmartTemplateStep6 from "./business/waiverbuilder/BusinessSmartTemplateStep6";
import BusinessSmartTemplateStep7 from "./business/waiverbuilder/BusinessSmartTemplateStep7";
import BusinessSmartTemplateStep8 from "./business/waiverbuilder/BusinessSmartTemplateStep8";
import { AdminManageBusinessType } from "./administrator/businesstype/AdminManageBusinessType";
import { AdminWaiverConfigure } from "./administrator/waiverbuilder/AdminWaiverConfigure";
import { AdminManageStateWaiverClauses } from "./administrator/state_waiver_clauses/AdminManageStateWaiverClauses";
import { AdminViewAuditLogs } from "./administrator/auditlogs/AdminViewAuditLogs";
import  BusinessLocationsPage from "./business/businesslocations/BusinessLocationsPage";
import QRCodes from "./business/commoncomponents/QRCodes";

//View Waiver
import ActiveWaiverViewer from "./business/waiversmanage/ActiveWaiverViewer";

import WaiverViewerLayout from "./business/waiverviewer/WaiverViewerLayout";
import WaiverOverview from "./business/waiverviewer/WaiverOverview";
import WaiverEligibilityRules from "./business/waiverviewer/WaiverEligibilityRules";
import WaiverSignerPreview from "./business/waiverviewer/WaiverSignerPreview";
import WaiverContent from "./business/waiverviewer/WaiverContent";
import WaiverVersionHistory from "./business/waiverviewer/WaiverVersionHistory";

//Edit Waiver
import WaiverEditorLayout from "./business/waivereditor/WaiverEditorLayout";
import WaiverContentEditor from "./business/waivereditor/WaiverContentEditor";
import WaiverEligibilityEditor from "./business/waivereditor/WaiverEligibilityEditor";
import WaiverMinorsEditor from "./business/waivereditor/WaiverMinorsEditor";
import WaiverReturningEditor from "./business/waivereditor/WaiverReturningEditor";
import WaiverLocationsEditor from "./business/waivereditor/WaiverLocationsEditor";
import WaiverReviewAndPublishEditor from "./business/waivereditor/WaiverReviewAndPublishEditor";
import WaiverSignatures from "./business/waiversmanage/WaiverSignatures";

import TermsOfService from "./staticpages/TermsOfService";
import PrivacyPolicy from "./staticpages/PrivacyPolicy";


//test scripts
import TestSignature from "./test_scripts/TestSignature";
import TestPDF from "./test_scripts/TestPDF";

//Frontend
import WaiverFlow from "./customer/signing_flow/controller/WaiverFlow";

function App() {
  //const { admin } = useAdminAuthContext();
  //const { customer, loading } = useCustomerAuthContext();
  //const { business, authChecked } = useBusinessAuthContext();

  return (
    <BrowserRouter>
      <Routes>

        <Route path="/" element={<Home />} />
        <Route path="/administrator/login" element={<AdminLogin />} />   
        <Route path="/business/register" element={<BusinessRegister />} />
        <Route
          path="/business/verify-email"
          element={<BusinessVerifyEmail />}
        />
        <Route path="/business/login" element={<BusinessLogin />} />     
        

        {/* Admin related routes */}

        <Route
          path="/administrator/dashboard"
          element={
            <AdminProtectedRoute>
              <AdminDashboard />
            </AdminProtectedRoute>
          }
        />

        <Route
          path="/administrator/manage"
          element={
            <AdminProtectedRoute>
              <AdminManage />
            </AdminProtectedRoute>
          }
        />

        <Route
          path="/administrator/admin/create"
          element={
            <AdminProtectedRoute>
              <AdminCreate />
            </AdminProtectedRoute>
          }
        />

        <Route
          path="/administrator/businesstype/manage"
          element={
            <AdminProtectedRoute>
              <AdminManageBusinessType />
            </AdminProtectedRoute>
          }
        />

        <Route
          path="/administrator/waiverbuilder/configure/:serviceid"
          element={
            <AdminProtectedRoute>
              <AdminWaiverConfigure />
            </AdminProtectedRoute>
          }
        />

        <Route
          path="/administrator/statewaiverclauses/manage"
          element={
            <AdminProtectedRoute>
              <AdminManageStateWaiverClauses />
            </AdminProtectedRoute>
          }
        />

        <Route
          path="/administrator/auditlogs/manage"
          element={
            <AdminProtectedRoute>
              <AdminViewAuditLogs />
            </AdminProtectedRoute>
          }
        />


        {/* Business related routes */}
        <Route
          path="/business/dashboard"
          element={
            <BusinessProtectedRoute>
              <BusinessDashboard />
            </BusinessProtectedRoute>
          }
        />
        
        <Route
          path="/business/qr-codes"
          element={
            <BusinessProtectedRoute>
              <QRCodes />
            </BusinessProtectedRoute>
          }
        />

        <Route
          path="/business/recent-activity"
          element={
            <BusinessProtectedRoute>
              <RecentActivityList />
            </BusinessProtectedRoute>
          }
        />

        <Route
          path="/business/edit-profile"
          element={
            <BusinessProtectedRoute>
              <BusinessEditProfile />
            </BusinessProtectedRoute>
          }
        />

        { /* <Route
          path="/business/manage-waiver"
          element={business ? <BusinessManageWaiver /> : <BusinessLogin />}
        /> */ }

        
        <Route
          path="/business/locations"
          element={
            <BusinessProtectedRoute>
              <BusinessLocationsPage />
            </BusinessProtectedRoute>
          }
        />

        
        
        {/* Waiver related routes */}
        <Route
          path="/business/waivers"
          element={
            <BusinessProtectedRoute>
              <BusinessExistingWaivers />
            </BusinessProtectedRoute>
          }
        />

        <Route
          path="/business/waiverbuilder/create"
          element={
            <BusinessProtectedRoute>
              <BusinessCreateWaiverType />
            </BusinessProtectedRoute>
          }
        />
        
        <Route
          path="/business/waiverbuilder/smart/step-1"
          element={
            <BusinessProtectedRoute>
              <BusinessSmartTemplateStep1 />
            </BusinessProtectedRoute>
          }
        />
        
        <Route
          path="/business/waiverbuilder/smart/:waiverId/step-2"
          element={
            <BusinessProtectedRoute>
              <BusinessSmartTemplateStep2 />
            </BusinessProtectedRoute>
          }
        />
        
        <Route
          path="/business/waiverbuilder/smart/:waiverId/step-2a"
          element={
            <BusinessProtectedRoute>
              <LocationCreateForm />
            </BusinessProtectedRoute>
          }
        />
        
        <Route
          path="/business/waiverbuilder/smart/:waiverId/step-3"
          element={
            <BusinessProtectedRoute>
              <BusinessSmartTemplateStep3 />
            </BusinessProtectedRoute>
          }
        />
        
        <Route
          path="/business/waiverbuilder/smart/:waiverId/step-4"
          element={
            <BusinessProtectedRoute>
              <BusinessSmartTemplateStep4 />
            </BusinessProtectedRoute>
          }
        />
        
        <Route
          path="/business/waiverbuilder/smart/:waiverId/step-5"
          element={
            <BusinessProtectedRoute>
              <BusinessSmartTemplateStep5 />
            </BusinessProtectedRoute>
          }
        /> 
        
        <Route
          path="/business/waiverbuilder/smart/:waiverId/step-6"
          element={
            <BusinessProtectedRoute>
              <BusinessSmartTemplateStep6 />
            </BusinessProtectedRoute>
          }
        />  
        
        <Route
          path="/business/waiverbuilder/smart/:waiverId/step-7"
          element={
            <BusinessProtectedRoute>
              <BusinessSmartTemplateStep7 />
            </BusinessProtectedRoute>
          }
        />  
        
        <Route
          path="/business/waiverbuilder/smart/:waiverId/step-8"
          element={
            <BusinessProtectedRoute>
              <BusinessSmartTemplateStep8 />
            </BusinessProtectedRoute>
          }
        />  
        
        <Route
          path="/business/waiverbuilder/custom"
          element={
            <BusinessProtectedRoute>
              <BusinessCustomWaiverComingSoon />
            </BusinessProtectedRoute>
          }
        />  

        <Route
          path="/business/waivers/signatures"
          element={
            <BusinessProtectedRoute>
              <WaiverSignatures />
            </BusinessProtectedRoute>
          }
        />

        <Route
          path="/business/waivers/signatures/:waiverId"
          element={
            <BusinessProtectedRoute>
              <WaiverSignatures />
            </BusinessProtectedRoute>
          }
        />
        
        <Route
          path="/business/waiverviewer/:waiverId"
          element={
            <BusinessProtectedRoute>
              <WaiverViewerLayout />
            </BusinessProtectedRoute>
          }
        >

          <Route index element={<Navigate to="overview" replace />} />

          <Route path="overview" element={<WaiverOverview />} />
          <Route path="eligibility" element={<WaiverEligibilityRules />} />
          <Route path="signer-preview" element={<WaiverSignerPreview />} />
          <Route path="content" element={<WaiverContent />} />
          <Route path="version-history" element={<WaiverVersionHistory />} />
        </Route>  


        <Route
          path="/business/active-waiver/:waiverId"
          element={
            <BusinessProtectedRoute>
              <ActiveWaiverViewer />
            </BusinessProtectedRoute>
          }
        />

        <Route
          path="/business/waivereditor/:waiverId"
          element={
            <BusinessProtectedRoute>
              <WaiverEditorLayout />
            </BusinessProtectedRoute>
          }
        >

        <Route
            index
            element={<Navigate to="content" replace />}
          />

          <Route path="content" element={<WaiverContentEditor />} />
          <Route path="eligibility" element={<WaiverEligibilityEditor />} />
          <Route path="minors" element={<WaiverMinorsEditor />} />
          <Route path="returning" element={<WaiverReturningEditor />} />
          <Route path="locations" element={<WaiverLocationsEditor />} />
        </Route>    

        <Route
            path="business/waivereditor/:waiverId/review"
            element={
              <BusinessProtectedRoute>
                <WaiverReviewAndPublishEditor />
              </BusinessProtectedRoute>
          }
        />


        { /*Test Script Routes */ }
        <Route
          path="/customer/test/signature"
          element={
            <CustomerProtectedRoute>
              <TestSignature />
            </CustomerProtectedRoute>
          }
        />
        <Route
          path="/customer/test/pdf"
          element={
                <CustomerProtectedRoute>
                    <TestPDF />
                </CustomerProtectedRoute>
            }
        />


            
        <Route
          path="/customer/home"
          element={
            <CustomerProtectedRoute>
                <TestCustomerHome />
            </CustomerProtectedRoute>           
          }
        />
        <Route
            path="/customer/test-login"
            element={<TestCustomerLogin />}
        />


        { /* <Route
            path="/start-waiver/:businessLocationSlug/:businessTypeSlug/:serviceSlug?"
            element={
                <CustomerProtectedRoute>
                    <WaiverFlow />
                </CustomerProtectedRoute>
            }
        />        

        <Route
            path="/guardian/:businessLocationSlug/:businessTypeSlug/:serviceSlug/:guardianToken?"
            element={
                <CustomerProtectedRoute>
                    <WaiverFlow />
                </CustomerProtectedRoute>
            }
        /> */ }

        <Route
            path="/start-waiver/:businessLocationSlug/:businessTypeSlug/:serviceSlug?"
            element={<WaiverFlow />}
        />

        <Route
            path="/guardian/:businessLocationSlug/:businessTypeSlug/:serviceSlug/:guardianToken?"
            element={<WaiverFlow />}
        />


       {/* Customer related routes 
        <Route path="/waiver/start/:business_slug" element={<WaiverStart />} />
        <Route path="/verify-otp" element={<CustomerVerifyOTP />} />
        <Route
          path="/customer/home"
          element={
            loading ? (
              <div className="text-center mt-20">Loading...</div>
            ) : customer ? (
              <CustomerHome />
            ) : (
              <WaiverStart />
            )
          }
        />*/}

         {/* <Route
          path="/customer/edit-profile"
          element={
            loading ? (
              <div className="text-center mt-20">Loading...</div>
            ) : customer ? (
              <CustomerEditProfile />
            ) : (
              <WaiverStart />
            )
          }
        />

        <Route
          path="/customer/dob"
          element={customer ? <CustomerDOB /> : <WaiverStart />}
        />

        <Route
          path="/customer/verify-guardian"
          element={customer ? <CustomerGuardianVerifyOTP /> : <WaiverStart />}
        />

        <Route
          path="/customer/edit-phone"
          element={customer ? <CustomerChangePhone /> : <WaiverStart />}
        />

        <Route
          path="/customer/verify-new-phone-otp"
          element={customer ? <CustomerVerifyNewPhone /> : <WaiverStart />}
        />*/}

        {/* privacy & terms route */}
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
